var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiVsVolumne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h50v50H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 25,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 11,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 17,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 5,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 39,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 41,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 33,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 43,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 31,
    r: 2,
    fill: "#75b6e1",
    className: "fill-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#75b6e1",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m2 25 13-6 10-8 10 6L48 5M2 39l13 2 10-8 10 10 13-12",
    className: "stroke-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiVsVolumne);
export default __webpack_public_path__ + "static/media/api_vs_volumne.a7fb79b4050e47f69e7ef5427c27b1de.svg";
export { ForwardRef as ReactComponent };